import { resolveLiveScreenshotsActiveFilter } from "./liveScreenshotsActiveFilter.js";
import { resolveLiveScreenshotsWscInstalledFilter } from "./liveScreenshotsWscInstalledFilter.js";

const STORAGE_KEY = "kfu_team_dashboard_screenshot_filters";

function readMap() {
    if (typeof localStorage === "undefined") return {};
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed)
            ? parsed
            : {};
    } catch {
        return {};
    }
}

function writeMap(map) {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map ?? {}));
}

export function resolveTeamDashboardScreenshotFiltersProfileId(userProfileId) {
    if (userProfileId != null && userProfileId !== "") {
        return String(userProfileId);
    }
    if (typeof localStorage === "undefined") return null;
    try {
        const fromStorage = localStorage.getItem("kaamfu_profile_id");
        return fromStorage ? String(fromStorage) : null;
    } catch {
        return null;
    }
}

/**
 * @param {string|number|null|undefined} userProfileId
 * @returns {{wsc_installed_filter?: string, active_filter?: string}}
 */
export function readTeamDashboardScreenshotFiltersFromStorage(userProfileId) {
    const profile_id = resolveTeamDashboardScreenshotFiltersProfileId(userProfileId);
    if (!profile_id) return {};

    const map = readMap();
    const entry = map[profile_id];

    return entry && typeof entry === "object" ? entry : {};
}

/**
 * @param {string|number|null|undefined} userProfileId
 * @param {{wsc_installed_filter?: string, active_filter?: string}} patch
 */
export function writeTeamDashboardScreenshotFiltersToStorage(userProfileId, patch) {
    const profile_id = resolveTeamDashboardScreenshotFiltersProfileId(userProfileId);
    if (!profile_id || !patch) return;

    const map = readMap();
    map[profile_id] = { ...(map[profile_id] ?? {}), ...patch };
    writeMap(map);
}

/**
 * Local per-field values win on reload (same precedence as mobile hydration).
 *
 * @param {string|number|null|undefined} userProfileId
 * @param {{ wsc_installed_filter?: string, active_filter?: string }} serverValues
 * @returns {{ wsc_installed_filter: string, active_filter: string }}
 */
export function hydrateTeamDashboardScreenshotFilters(
    userProfileId,
    serverValues = {},
) {
    const stored = readTeamDashboardScreenshotFiltersFromStorage(userProfileId);

    const wsc_source =
        stored.wsc_installed_filter !== undefined
            ? stored.wsc_installed_filter
            : serverValues.wsc_installed_filter;

    const active_source =
        stored.active_filter !== undefined
            ? stored.active_filter
            : serverValues.active_filter;

    return {
        wsc_installed_filter: resolveLiveScreenshotsWscInstalledFilter(wsc_source),
        active_filter: resolveLiveScreenshotsActiveFilter(active_source),
    };
}